import { default as utils } from "./../utils.min.js";

function changeImage() {
	const images = document.querySelectorAll(".img-switch");

	let newNum = utils.getRandomInt(1, 11); // 11 products
	const $exactImage = document.querySelector(`.switch-${newNum}`);

	// hide all images
	images.forEach((image) => {
		image.classList.add("hidden");
	});

	// Show newNum image
	$exactImage.classList.toggle("hidden");
}

$(function () {
	setInterval(changeImage, 3000);
});
